import { Injectable } from '@angular/core';
import { Card } from '../../dto/card';
import { CrudService } from '../../services';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';

import {BankTransferLoad} from '../../dto/bankTransferLoad';

@Injectable({
  providedIn: 'root'
})
export class BankTransferRefundService implements CrudService<BankTransferLoad> {
  readonly apiPath = 'bank-transfer-refund/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<BankTransferLoad>;
  }


  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string) {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set( 'sortDirection', sortDirection )
      .set( 'someAdditionalData', someAdditionalData );
    return this.http.get(this.apiPath, { params }) as Observable<DataListModel<BankTransferLoad>>;
  }

  refundLoad(id: number): Observable<BankTransferLoad> {
    return this.http.post(this.apiPath +'refund', {id}) as Observable<BankTransferLoad>;
  }

  refundLoads( idList: any[] ): Observable<Object>  {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );
    return this.http.get( this.apiPath + 'refunds', { params: httpParams } );
  }

  add(item: BankTransferLoad): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  update(item: BankTransferLoad) {
    return this.http.put(this.apiPath, item) as Observable<BankTransferLoad>;
  }


  delete(id: any) {
    return this.deleteMany([id]);
  }
  restore(id: any) {
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]) {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]) {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }

}
